export default __webpack_public_path__ + "static/media/depositphotos_1.d21c85fb.png";